import { render, staticRenderFns } from "./Summernote.vue?vue&type=template&id=bdd865d2&"
import script from "./Summernote.vue?vue&type=script&lang=js&"
export * from "./Summernote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports